import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '倉庫カレンダー（日历）',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: true,
  rolesOnly: ['FCChina'],
  order: 1,
};
